import React from 'react'
import i, { PostProcessorModule } from 'i18next'
import Airtable from 'airtable'
import { compiler } from 'markdown-to-jsx'
import NextLink from 'next/link'
import { trim } from 'lib/trim'

const Link = ({ href, className, children }) => {
	href = href.replace( /https?:\/\/\/?([^.]+)$/, '/$1' )

	if ( href[ 0 ] === '/' ) {
		return React.createElement(
			NextLink,
			{ href, scroll: false, legacyBehavior: true },
			React.createElement( 'a', { className }, children )
		)
	} else {
		return React.createElement(
			'a',
			{ href, target: '_blank', className: 'u', rel: 'noopener' },
			children
		)
	}
}

const LiWithoutP = ( props ) => (
	React.createElement(
		'li',
		null,
		// Filter out any <p>s that have gotten into the last list item because of a
		// markdown-to-jsx parsing snafoo
		React.Children.map( props.children, child => (
			child.type === P ? child.props.children : child
		) )
	)
)

const P = ( props ) => {
	return React.createElement(
		'p',
		null,
		// Add .cta class if the paragraph only contains an (internal) link
		( props.children.length === 1 && props.children[ 0 ].type === Link
			? React.cloneElement( props.children[ 0 ], { className: 'cta' })
			: props.children
		)
	)
}

const Markdown: PostProcessorModule = {
	type: 'postProcessor',
	name: 'markdown-jsx',
	process: function( value ) {
		return compiler( value, {
			overrides: {
				li: { component: LiWithoutP },
				a: { component: Link },
				p: { component: P },
			},
		})
	},
}

export async function getTranslations({ page }) {
	const airtable = new Airtable({ apiKey: process.env.AIRTABLE_KEY })
	const base = airtable.base( process.env.AIRTABLE_BASE )

	const filterByFormula = ( page ? `OR( page='all', page='${page}' )` : '' )
	const translations = {
		en: { app: {} },
		nl: { app: {} },
	}
	await base( 'Translations' ).select({ filterByFormula }).eachPage(
		( records, next ) => {
			records.forEach( ({ fields: { key, en, nl } }) => {
				if ( trim( en ) ) translations.en.app[ key as string ] = trim( en )
				if ( trim( nl ) ) translations.nl.app[ key as string ] = trim( nl )
			})
			next()
		}
	)

	return translations
}

export default function useTranslations( translations ) {
	i.use( Markdown ).init({
		ns: 'app',
		defaultNS: 'app',
		fallbackLng: 'en',
		lng: 'nl',
		keySeparator: false,
		nsSeparator: false,
		resources: translations,
		interpolation: {
			escapeValue: false,
		},
	})
}
